import { render, staticRenderFns } from "./VideoOnly.vue?vue&type=template&id=7fd386b0&"
import script from "./VideoOnly.vue?vue&type=script&lang=js&"
export * from "./VideoOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports